import { ISeriesApi, LineData, SeriesType, Time } from 'lightweight-charts'
import Chart from './chart'
import { MultiStrikeSeriesSnapshot } from './multiStrikeChartSnapshotEquality'
import LineSeries from './series/lineSeries'

function lastPointFromLineSeries(lineSeries: LineSeries | undefined): LineData<Time> | undefined {
    const data = lineSeries?.data
    if (!data?.length) return undefined
    return data[data.length - 1]
}

/** Latest candle per series — used as the default metadata baseline. */
export function buildLatestMultiStrikeStringSnapshot(chart: Chart): MultiStrikeSeriesSnapshot {
    const result: MultiStrikeSeriesSnapshot = {}

    for (const [secKey, lineSeries] of Object.entries(chart.dataManager.seriesApis)) {
        const point = lastPointFromLineSeries(lineSeries)
        if (point) result[secKey] = point
    }
    for (const [key, lineSeries] of Object.entries(chart.dataManager.cumSeriesApis)) {
        const point = lastPointFromLineSeries(lineSeries)
        if (point) result[key] = point
    }
    return result
}

/** Crosshair values with latest-candle fallback for missing points at the hovered time. */
export function buildCrosshairMultiStrikeStringSnapshot(chart: Chart): MultiStrikeSeriesSnapshot {
    const result = buildLatestMultiStrikeStringSnapshot(chart)
    const crosshairPoint = chart.crossHairInfo?.point
    const seriesData = chart.crossHairInfo?.seriesData as
        | Map<ISeriesApi<SeriesType, Time>, LineData<Time>>
        | undefined

    if (!crosshairPoint || !seriesData) {
        return result
    }

    for (const [secKey, lineSeries] of Object.entries(chart.dataManager.seriesApis)) {
        if (lineSeries?.seriesApi) {
            const point = seriesData.get(lineSeries.seriesApi)
            if (point) result[secKey] = point
        }
    }
    for (const [key, lineSeries] of Object.entries(chart.dataManager.cumSeriesApis)) {
        if (lineSeries?.seriesApi) {
            const point = seriesData.get(lineSeries.seriesApi)
            if (point) result[key] = point
        }
    }
    return result
}

/** @deprecated Use buildLatestMultiStrikeStringSnapshot or buildCrosshairMultiStrikeStringSnapshot. */
export function buildMultiStrikeStringSnapshot(chart: Chart): MultiStrikeSeriesSnapshot {
    return buildCrosshairMultiStrikeStringSnapshot(chart)
}
